import CustomerForm from '../components/CustomerForm';
import { useNavigate, useSearchParams } from 'react-router-dom';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import { Stack } from '@mui/material';
import { useMutateCustomerHandler } from '../dataHandlers/mutateCustomerHandler';
import { DEFAULT_CUSTOMER_TYPE } from '../../../constants/defaults';
import { useState, useEffect } from 'react';
import { useTranslatedMessages } from '../../../hooks/useTranslatedMessages';
import { usePermissions } from '../../../hooks/usePermissions';
import { CREATE_CUSTOMER } from '../../../constants/eInvoicePermissions';
import { useActionDeniedSnackbar } from '../../../hooks/useActionDeniedSnackbar';

const initialData = {
  participant_id: '',
  scheme_agency_id: null,
  authority_name: null,
  company_id: null,
  party_tax_scheme: {
    tax_scheme: '',
    company_id: '',
  },
  telephone: '',
  postal_address: {
    street_name: '',
    additional_street_name: '',
    address_line: '',
    city_name: '',
    country_subentity: '',
    country_code: null,
    postal_zone: '',
    country: '',
  },
  email: '',
  party_name_in_local_language: '',
  party_name: '',
  name: '',
  customer_type: DEFAULT_CUSTOMER_TYPE,
};

export default function CreateCustomersPage() {
  const { customers: c } = useTranslatedMessages();
  const page = c?.pages?.create ?? {};
  useDocumentTitle(page?.document_title ?? 'New Customer Form');
  const navigate = useNavigate();
  const { loading, hasEInvoicePermission } = usePermissions();
  const showActionDeniedSnackbar = useActionDeniedSnackbar();
  const [searchParams] = useSearchParams();
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Read the customerType from URL query parameters
  const customerType = searchParams.get('customerType');

  useEffect(() => {
    if (loading) {
      return;
    }
    if (!hasEInvoicePermission(CREATE_CUSTOMER)) {
      showActionDeniedSnackbar();
      navigate('/customers', { replace: true });
    }
  }, [loading, hasEInvoicePermission, showActionDeniedSnackbar, navigate]);

  const onCustomerCreated = () => {
    navigate('/customers');
  };

  const { onSubmit, error, isPending } = useMutateCustomerHandler({ onSuccess: onCustomerCreated });

  // Reset isSubmitting when mutation completes
  useEffect(() => {
    if (!isPending && isSubmitting) {
      setIsSubmitting(false);
    }
  }, [isPending, isSubmitting]);

  const handleSubmit = async (payload) => {
    setIsSubmitting(true);
    delete payload.peppol_participant;
    onSubmit(payload, false);
  };

  const handleCancel = async () => navigate('/customers');

  return (
    <Stack direction="column" sx={{ mt: '-2rem' }}>
      <CustomerForm
        onSubmit={handleSubmit}
        onCancel={handleCancel}
        initialData={initialData}
        apiErrors={error}
        customerType={customerType}
        isLoading={isPending || isSubmitting}
      ></CustomerForm>
    </Stack>
  );
}
